import React from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, Loader2, LogOut } from "lucide-react";
import { http, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { homeForRole } from "@/lib/menu";
import { Logo } from "@/components/Logo";

// A3: change one's own password. When the owner switched on "wajib ganti
// password", a user with a temporary password lands here and can only do this
// (the server refuses everything else).
export default function GantiPassword() {
  const { user, setUser, logout } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = React.useState({ lama: "", baru: "", ulang: "" });
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState(null);
  const wajib = !!user?.wajib_ganti_password;

  const simpan = async (e) => {
    e.preventDefault();
    setMsg(null);
    if (f.baru !== f.ulang) return setMsg({ ok: false, text: "Ulangi password baru dengan sama persis." });
    if (f.baru.length < 8) return setMsg({ ok: false, text: "Password baru minimal 8 karakter." });
    setBusy(true);
    try {
      const u = (await http.post("/auth/ganti-password", { password_lama: f.lama, password_baru: f.baru })).data;
      setUser(u);
      setF({ lama: "", baru: "", ulang: "" });
      if (wajib) navigate(homeForRole(u.role), { replace: true });
      else setMsg({ ok: true, text: "Password diganti. Perangkat lain yang masih login akan diminta login ulang." });
    } catch (err) {
      setMsg({ ok: false, text: formatApiErrorDetail(err.response?.data?.detail) || err.message });
    } finally {
      setBusy(false);
    }
  };

  const input = (k, label, ac) => (
    <label className="block text-[13px] font-semibold text-slate-200">{label}
      <input type="password" autoComplete={ac} data-testid={`gp-${k}`} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
        className="mt-1 w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 normal-case tracking-normal" required />
    </label>
  );

  return (
    <div data-testid="ganti-password-page" className="min-h-screen bg-slate-950 text-slate-200 flex items-center justify-center px-4">
      <form onSubmit={simpan} className="w-full max-w-md rounded-xl border border-slate-800 bg-slate-900/70 p-6 space-y-4">
        <div className="flex flex-col items-center gap-2"><span className="inline-flex rounded-lg bg-soq-biru px-3 py-2"><Logo varian="putih" className="h-8 w-auto" /></span></div>
        <h1 className="flex items-center gap-2 text-lg font-semibold text-slate-100"><KeyRound size={18} /> Ganti password</h1>
        {wajib && (
          <p data-testid="gp-wajib" className="rounded-lg border border-amber-500/40 border-l-4 border-l-amber-500 bg-amber-500/10 px-3 py-2 text-sm text-amber-200">
            {user?.password_sementara ? "Password Anda masih password sementara dari Owner. Ganti dulu sebelum memakai aplikasi."
              : "Akun Anda diaktifkan kembali setelah berada di Sampah. Ganti password dulu sebelum memakai aplikasi."}
          </p>
        )}
        <p className="text-xs text-slate-500">Login sebagai <b>{user?.username}</b>. Minimal 8 karakter, berbeda dari password lama dan username. Jangan berikan password ke orang lain, termasuk pengelola aplikasi.</p>
        {input("lama", "Password lama / sementara", "current-password")}
        {input("baru", "Password baru", "new-password")}
        {input("ulang", "Ulangi password baru", "new-password")}
        <button type="submit" disabled={busy} data-testid="gp-simpan"
          className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-amber-500 px-4 py-2.5 text-sm font-semibold text-slate-950 disabled:opacity-50">
          {busy ? <Loader2 size={14} className="animate-spin" /> : <KeyRound size={14} />} Simpan password baru
        </button>
        {msg && <p data-testid="gp-msg" className={`text-sm ${msg.ok ? "text-emerald-300" : "text-red-300"}`}>{msg.text}</p>}
        <div className="flex justify-between text-xs">
          {!wajib ? <button type="button" onClick={() => navigate(-1)} className="text-slate-400 hover:text-slate-200">← Kembali</button> : <span />}
          <button type="button" onClick={logout} className="inline-flex items-center gap-1 text-slate-400 hover:text-red-300"><LogOut size={12} /> Logout</button>
        </div>
      </form>
    </div>
  );
}
